import React from "react";
import { getField } from "../../util/DynamicItemUtils";
import Truncate from "react-truncate";

export default function StandardsAndInterpretations({ item }: any) {
  const originalUrl = getField(item, "pageurl");
  let finalUrl = originalUrl || "";

  if (finalUrl.length > 0) {
    switch (getField(item, "standardsgroups")) {
      case "Attestation":
        finalUrl = originalUrl;
        break;

      case "Ethics & Independence":
        finalUrl = originalUrl.replace(
          "attestation-standards",
          "ethics-independence-rules"
        );
        break;

      case "Quality Control":
        finalUrl = originalUrl.replace("attestation-standards", "qc-standards");
        break;

      case "Auditing Standards":
        finalUrl = originalUrl.replace(
          "attestation-standards",
          "auditing-standards"
        );
        break;

      case "Archived Standards":
        finalUrl = originalUrl.replace(
          "attestation-standards",
          "archived-standards"
        );
        break;

      case null:
        finalUrl = originalUrl.replace(
          "attestation-standards",
          "archived-standards"
        );
        break;

      case "":
        finalUrl = originalUrl.replace(
          "attestation-standards",
          "archived-standards"
        );
        break;

      default:
        finalUrl = originalUrl.replace(
          "attestation-standards",
          "archived-standards"
        );
        break;
    }
  }

  return (
    <div>
      <p className="lead-text-lt">
        {getField(item, "standardpagetypes") === "Auditing Interpretations"
          ? "Auditing Interpretation"
          : "Standards"}
      </p>
      <h3>
        {finalUrl.length > 0 ? (
          <a href={finalUrl}>{getField(item, "title")}</a>
        ) : (
          <div>{getField(item, "title")}</div>
        )}
      </h3>
      <div className="hawk-row">
        {getField(item, "standardsgroups") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Standard Type</div>
            <div className="lead-text-st">
              {getField(item, "standardsgroups")}
            </div>
          </div>
        )}
      </div>
      <div className="hawk-row">
        {getField(item, "pagecontent") && (
          <div className="hawk-column">
            <div className="hawk-summary-text">
              <Truncate lines={3}>{getField(item, "pagecontent")}</Truncate>
            </div>
          </div>
        )}
      </div>
      {finalUrl.length > 0 && (
        <a href={finalUrl} className="hawk-read-more">
          Read More
        </a>
      )}
    </div>
  );
}
